import { Injectable } from '@angular/core';

import { BaseService } from './base.service';
import { ListModel } from '../model/list.model';

@Injectable()
export class ListService {

  path = '/list';

  constructor(private baseService: BaseService) { }

  getPaginated(init: number, end: number) {
    return this.baseService.get(this.path, '', {
      init, end, without_values: true,
    });
  }

  findByPk(id: number) {
    return this.baseService.get(this.path, '/' + id);
  }

  post(list: ListModel) {
    return this.baseService.post(this.path, '/', list);
  }

  put(list: ListModel) {
    return this.baseService.put(this.path, '/', list);
  }

  delete(id: number) {
    return this.baseService.delete(this.path, '/' + id);
  }

  save(list: ListModel) {
    if (list.id) { return this.put(list); } else { return this.post(list); }
  }

  // integration

  integration() {
    return this.baseService.get('/list-value', '/integration/run', {});
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/list.service.ts